import { IApiResponse } from "../../../@types/api-response.type";
import { ICustomer } from "../../../@types/customer.type";
import { IFilterDownload, IFilterRequest } from "../../../@types/filter-request.type";
import { IKeyValue } from "../../../@types/key-value.type";
import { IReportMetricsBody } from "../../../@types/reports-metrics.type";
import { downloadExcel } from "../../../utils/download";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils";

export const getTotalCustomers = async () => {
  try {
      const { data } = await Api.get(`/api/Customer/GetAllCustomers`);
      return data
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar Clientes'))
  }
}

export const getAllCustomers = async (skip?: number, total?: number) => {
    try {
        let url = `/api/Customer/GetCustomers`;

        const params = new URLSearchParams();
        if (skip !== undefined) {
            params.append('skip', skip.toString());
        }
        if (total !== undefined) {
            params.append('total', total.toString());
        }
        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const { data } = await Api.get(url);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Clientes'))
    }
}

export const searchCustomers = async (filter: IFilterRequest) => {
    try {
        const { data } = await Api.post(`/api/Customer/searchCustomers`, filter) ;
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Clientes'))
    }
}

export const getAllCustomersNoPagination = async () => {
    try {
        const { data } = await Api.get(`/api/Customer/GetAllCustomers`)
        return data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos Clientes'))
    } 
}

export const getCustomerByName = async (name: string) => {
    try {
        const { data } = await Api.get(`/api/Customer/GetCustomerByName?name=${name}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Clientes por Nome'))
    } 
}

export const getCustomerById = async (id: string) => {
    try {
        const { data } = await Api.get(`/api/Customer/GetCustomerById?id=${id}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Clientes por Id'))
    } 
}

export const addOrUpdateCustomer = async (customerToApi:ICustomer) => {
    try {
        const { data } = await Api.post("/api/Customer/AddOrUpdateCustomer",
        customerToApi);
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar ou atualizar Cliente'))
    } 
};

export const deleteCustomer = async (id: string) => {
    try {
        const { data } = await Api.delete(`/api/Customer/DeleteCustomer/${id}`);
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao deletar Clientes'))
    } 
};

export const getCustomersMetrics = async (customer: IReportMetricsBody) => {
    try {
        const { data } = await Api.post("/api/Customer/GetCustomersMetrics",
        {"id": customer.id, "startTime": customer.startTime, 
        "endTime": customer.endTime, "timeType": customer.timeType});
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Clientes'))
    } 
}

export const getAllCustomersIdsAndNames = async () : Promise<IKeyValue[] | ApiException> => {
    try {
        // Customer has no dedicated "IdsAndNames" route like Area/CostCenter/Position/Project do -
        // GetAllCustomers already returns this exact Key/Value shape, so it's reused here instead
        // of adding a duplicate backend endpoint.
        const response = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Customer/GetAllCustomers`)
        return response.data.result;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Clientes por Nome e Id'))
    }
  }

  
export const downloadCustomersToExcel = async (filters: IFilterDownload) : Promise<void> => {
    try {
        const response = await Api.post(
            `/api/Customer/DownloadCustomersToExcel`, 
            filters  , { responseType: "blob" });

        downloadExcel("Clientes", response.data);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao fazer download dos clientes por excel'))
    }    
  }

export const downloadCustomersReportToExcel = async (filters: IReportMetricsBody) : Promise<void> => {
    try {
        const response = await Api.post(
            `/api/Customer/DownloadCustomersReportToExcel`, 
            filters  , { responseType: "blob" });

        downloadExcel("Relatorio-Clientes", response.data);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao fazer download do relatorio de clientes via excel'))
    }    
}

export const CustomersService = {
    getAllCustomers,
    addOrUpdateCustomer,
    deleteCustomer,
    getCustomersMetrics,
    getAllCustomersIdsAndNames,
    getAllCustomersNoPagination,
    downloadCustomersToExcel,
    downloadCustomersReportToExcel
}
